<script>

    import layer from "@/mixins/mapboxLayer"

    export default{

        mixins:[layer],
        
        name:"runners",

        data(){
            return {
                loadDelay:4,
                geoGsonTemp:false
            }
        },

        computed:{
            geoJSON:function(){
                return this.geoGsonTemp;//this.$store.getters.kms;
            },
        },

        watch:{
            geoJSON:function(){
                // setTimeout( ()=>this.animateFeatures(4, false),0);
            }
        },


        created:function(){

              this.loadData();
        
        },


        methods:{

            loadData:function(){

                  $.getJSON( window.API.tracker+"get_runners_position", (data)=>{
                            this.geoGsonTemp = data;
                            setTimeout(this.loadData,1000);
                    })
            },
        },

        style: function () {
            return {
                "type": "symbol",
                "source": this.sourceName,
                "layout": {
                    "icon-image": "marker_runner",
                    "icon-anchor": "bottom",
                    "icon-allow-overlap": false,
                    "text-field": "{cd_team}",
                    "text-anchor": "bottom",
                    "text-line-height": 1,
                    "text-optional": true,
                    "text-offset": {
                        "base": 1,
                        "stops": [
                            [10, [0, -1]],
                            [14, [0, -1]]
                        ],
                    },
                    "text-padding": 0,
                    "text-size": {
                        "base": 1,
                        "stops": [
                            [10, 6],
                            [14, 12]
                        ],
                    },
                    "icon-size": {
                        "base": 1,
                        "stops": [
                            [9, 0.1],
                            [10, 0.2],
                            [14, 1]
                        ],
                    },
                },
                "paint": {
                    "text-color": "white",
                    "text-halo-color": "white",
                    "text-halo-width": 0.4,
                    "text-halo-blur": 0.2,
                    "text-opacity": {
                        "base": 1,
                        "stops": [
                            [11.4, 0],
                            [13, 1]
                        ],
                    },
                    "icon-opacity": {
                        "base": 1,
                        "stops": [
                            [11.3, 0],
                            [11.4, 1]
                        ],
                    },
                }
            }
        }

    }


</script>